import { ReactElement } from 'react';
import { Field, useFormikContext, getIn } from 'formik';
import { CheckboxInput, TileRadio } from '@components';
import { tile } from '@interfaces/interfaces';
import { iFVSFormValues } from '@services/FVSService';
import gridStyles from '@pages/forms/Grid.module.scss';
import classnames from 'classnames';
import styles from './FVSStep5.module.scss';

function FVSStep5(): ReactElement {
  const { values, touched }: { values: iFVSFormValues; touched: any } = useFormikContext();
  const hasTouchedApplicationLodger = getIn(touched, 'ApplicationLodger');
  const LodgedByVictim = (): ReactElement => (
    <>
      <div>I am the person affected by family violence</div>
    </>
  );
  const LodgedByRepresentative = (): ReactElement => (
    <>
      <div>I am the affected person's authorised representative, lawyer or advocate</div>
    </>
  );
  const applicationLodger: tile[] = [
    {
      body: <LodgedByVictim />,
      value: 'LodgedByVictim',
    },
    {
      body: <LodgedByRepresentative />,
      value: 'LodgedByRepresentative',
    },
  ];

  return (
    <div className={gridStyles.form}>
      <div className="vfH2">Who is lodging the application</div>
      <div className={gridStyles.gridColFull}>
        <div
          className={classnames({
            vfH3: true,
            [styles.titleError]: hasTouchedApplicationLodger && !values.ApplicationLodger,
          })}>
          Select the statement that best describes you?
        </div>
        <Field
          classname={styles.tile}
          name="ApplicationLodger"
          tileContainer
          component={TileRadio}
          tileData={applicationLodger}
          isMandatory />
      </div>
      {values.ApplicationLodger === 'LodgedByRepresentative' && (
        <div className={gridStyles.gridColFull}>
          <Field component={CheckboxInput} name="ConsentToThirdParty" title="The applicant has consented to me making this application on their behalf." />
        </div>
      )}
    </div>
  );
}
export default FVSStep5;
